/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "schoolboosterapirest",
            "endpoint": "https://st3obpcxvi.execute-api.eu-west-1.amazonaws.com/preprod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://nz47rbtnq5hqvitrjnfzx6hkqq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:e931b276-06eb-470c-b0f6-9f7f6ba44de1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_kAHUEZ6hr",
    "aws_user_pools_web_client_id": "5g26p1g38l20ehss1npecsumms",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "schoolboostertsfront8150858f70ed42ef84dd37aa444123638-preprod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
